import { NPS_ID, NPS_SURVEY_PARAMS } from './survey-feedback/editSurveyFeedbackBox.controller';


//
// Helper functions for creation of new elements when drag and dropping from toolbox panel
//

export function createBoxForPanelDragAndDrop(services, context, callbacks, boxParams) {
  const joint = services.joint;

  switch (boxParams.boxType) {
    case 'html.QuestionBox':
    case 'html.MessageWithChoiceBox':
      return createQuestionBox(services, boxParams, context);
    case 'html.MessageWithoutQRBox':
      return createMessageWithoutQRBox(services, boxParams);
    case 'html.SurveyFeedbackBox':
      return createSurveyFeedbackBox(services, boxParams);
    case 'html.SubBotBox':
      return createSubBotBox(services, boxParams);
    case 'html.ListPickerBox':
      return createListPickerBox(services, boxParams, context);
    case 'html.WhatsappListMessageBox':
      return createWhatsappListMessageBox(services, boxParams);
    case 'html.WhatsappMessageWithButtonsBox':
      return createWhatsappMessageWithButtonsBox(services, boxParams);
    case 'html.WhatsappTemplateBox':
      return createWhatsappTemplateBox(services, boxParams);
    case 'html.InstagramCarrouselBox':
      return createInstagramCarrouselBox(services, boxParams);
    case 'html.GbmCarrouselBox':
      return createGbmCarrouselBox(services, boxParams);
    case 'html.LineCarrouselBox':
      return createLineCarrouselBox(services, boxParams);
    case 'html.InMessageCarouselBox':
      return createInMessageCarouselBox(services, boxParams);
    case 'html.ImageCarrouselBox':
      return createImageCarrouselBox(services, boxParams);
    case 'html.ImageMapBox':
      return createImageMapBox(services, boxParams, context);
    case 'html.BotConnectorBox':
      return createBotConnectorBox(services, boxParams);
    case 'html.FacebookProductBox':
      return createFacebookProductBox(services, boxParams);
    case 'html.RecurringNotifBox':
      return createRecurringNotifBox(services, boxParams);
    case 'html.ActionBox':
      return createBoxWithNext(services, boxParams, joint.shapes.html.ActionBox);
    case 'html.HandoverBox':
      return createHandoverBoxWithTimeoutChild(services, boxParams);
    case 'html.GetStartedBox':
      return createBoxWithNext(services, boxParams, joint.shapes.html.GetStartedBox);
    case 'html.SurveyStartedBox':
      return createBoxWithNext(services, boxParams, joint.shapes.html.SurveyStartedBox);
    case 'html.NewConversationBox':
      return createBoxWithNext(services, boxParams, joint.shapes.html.NewConversationBox);
    case 'html.UnexpectedUserInputBox':
      return createBoxWithNext(services, boxParams, joint.shapes.html.UnexpectedUserInputBox);
    case 'html.AgentShortcutBox':
      return createBoxWithNext(services, boxParams, joint.shapes.html.AgentShortcutBox);
    case 'html.MassMessagingEntryPointBox':
      return createBoxWithNext(services, boxParams, joint.shapes.html.MassMessagingEntryPointBox);
    case 'html.ReceiveControlBox':
      return createBoxWithPostbackPayload(services, boxParams, joint.shapes.html.ReceiveControlBox, 'thread_control_metadata', true, context, callbacks);
    case 'html.MessengerMDotMeLinkBox':
      return createBoxWithPostbackPayload(services, boxParams, joint.shapes.html.MessengerMDotMeLinkBox, 'thread_control_metadata', true, context, callbacks);
    case 'html.ExternalEndpointEntryPointBox':
      return createBoxWithPostbackPayload(services, boxParams, joint.shapes.html.ExternalEndpointEntryPointBox, 'thread_control_metadata', true, context, callbacks);
    case 'html.LinkWithRefEntryPointBox':
      return createBoxWithPostbackPayload(services, boxParams, joint.shapes.html.LinkWithRefEntryPointBox, 'thread_control_metadata', true, context, callbacks);
    case 'html.ClickToMessengerBox':
      return createBoxWithPostbackPayload(services, boxParams, joint.shapes.html.ClickToMessengerBox, 'postback_payload', true, context, callbacks);
    case 'html.SponsoredBzcMessageBox':
      return createBoxWithPostbackPayload(services, boxParams, joint.shapes.html.SponsoredBzcMessageBox, 'postback_payload', true, context, callbacks);
    case 'html.LineRichMenuBox':
      return createBoxWithPostbackPayload(services, boxParams, joint.shapes.html.LineRichMenuBox, 'postback_payload', true, context, callbacks);
    case 'html.MessengerCustomAppEventFromVariableBox':
      return createBoxWithNext(services, boxParams, joint.shapes.html.MessengerCustomAppEventFromVariableBox);
    case 'html.MessengerGenericTemplateAManoBox':
      return createMessengerGenericTemplateAManoBox(services, boxParams);
    case 'html.MessengerMediaTemplateAManoBox':
      return createMessengerMediaOrButtonTemplateBox(services, boxParams, joint.shapes.html.MessengerMediaTemplateAManoBox);
    case 'html.MessengerButtonTemplateAManoBox':
      return createMessengerMediaOrButtonTemplateBox(services, boxParams, joint.shapes.html.MessengerButtonTemplateAManoBox);
    case 'html.BZCRichLinkAManoBox':
      return createBZCRichLinkAManoBox(services, boxParams);
    case 'html.IfThenElseBox':
      return createIfThenElseBox(services, boxParams);
    case 'html.BHNBHBox':
      return createBHNBHBox(services, boxParams);
    case 'html.EmailRequestForNotificationBox':
      return createEmailRequestForNotificationBox(services, boxParams);
    case 'html.PhoneRequestForNotificationBox':
      return createPhoneRequestForNotificationBox(services, boxParams);
    case 'html.UserLanguagesBox':
      return createUserLanguagesBox(services, boxParams);
    case 'html.UserCountriesBox':
      return createUserCountriesBox(services, boxParams);
    case 'html.OptinNotOptinBox':
      return createOptinNotOptinBox(services, boxParams);
    case 'html.FirstConversationEverBox':
      return createBoxWithNext(services, boxParams, joint.shapes.html.FirstConversationEverBox);
    case 'html.FollowingConversationsBox':
      return createBoxWithNext(services, boxParams, joint.shapes.html.FollowingConversationsBox);
    case 'html.WhatsappCartSentBox':
      return createBoxWithNext(services, boxParams, joint.shapes.html.WhatsappCartSentBox);
    case 'html.ForkWithDelayBox':
      return createForkWithDelayBox(services, boxParams);
    case 'html.TriggerSurveyBox':
      return createTriggerSurveyBox(services, boxParams);
    case 'html.SetCustomFieldBox':
      return createSetCustomFieldBox(services, boxParams);
    case 'html.PromoCodeBox':
      return createPromoCodeBox(services, boxParams);
    case 'html.ConfirmBox':
      return createConfirmBox(services, boxParams, context);
    case 'html.ConditionsVariablesMultipleBox':
      return createConditionsVariablesMultipleBox(services, boxParams);
    case 'html.WhatsappWelcomeMessageBox':
      return createWhatsappWelcomeMessageBox(services, boxParams);
    case 'html.ConditionsOnUserInputBox':
      return createConditionsOnUserInputBox(services, boxParams);
    case 'html.ConditionsOnCustomFieldsBox':
      return createConditionsOnCustomFieldsBox(services, boxParams);
    case 'html.OptinCTSBox':
      return createOptinCTSBox(services, boxParams);
    case 'html.AiConnectorBox':
      return createAiConnectorBox(services, boxParams);
    case 'html.WaitForMessageBox':
      return createWaitForMessageBox(services, boxParams, context);
    case 'html.ApiConnectorBox':
      return createApiConnectorBox(services, boxParams, context);
    case 'html.NoteBox':
      return createNoteBox(services, boxParams, context);
    case 'html.AiSatisfactionBox':
      return createAISatisfactionBox(services, boxParams, context);
    case 'html.TextMatchBox':
      return createTextMatchBox(services, boxParams, context);
  }
}

function createQuestionBox(services, boxParams, context) {
  let box = boxParams.boxType === 'html.QuestionBox' ? new services.joint.shapes.html.QuestionBox({
    id: boxParams.ids[0],
    position: boxParams.position,
    content: 'Question'
  })
    : new services.joint.shapes.html.MessageWithChoiceBox({
      id: boxParams.ids[0],
      position: boxParams.position,
      content: 'Question',
      menuChoice: 1
    });

  boxParams.graph.addCell(box);


  if (boxParams.boxType === 'html.QuestionBox') {
    // Add the missing mandatories buttons.
    let questionBoxView = boxParams.paper.findViewByModel(box);
    questionBoxView.numberOfButtons = 0;
    if (questionBoxView.getConfigurationOption) {
      Array.from({ length: questionBoxView.getConfigurationOption()?.minAnswers || 0 }).forEach(() => {
        questionBoxView.addAnswer();
      });
    }
  } else if (boxParams.boxType === 'html.MessageWithChoiceBox') {
    let boxView = boxParams.paper.findViewByModel(box);
    boxView.addAnswer(services.$translate.instant('parameters/quick_replies/details/default_answer'), 'next-box-by-default', false);
  }

  return box;
}

function createMessageWithoutQRBox(services, boxParams) {
  let box = new services.joint.shapes.html.MessageWithoutQRBox({
    id: boxParams.ids[0],
    position: boxParams.position,
    content: 'Message'
  });
  let n = new services.joint.shapes.html.Next({
    id: boxParams.ids[1]
  });
  box.embed(n);
  boxParams.graph.addCells([box, n]);
  let boxView = boxParams.paper.findViewByModel(box);
  boxView.resizeBox();
  return box;
}

function createSurveyFeedbackBox(services, boxParams) {
  let box = new services.joint.shapes.html.SurveyFeedbackBox({
    id: boxParams.ids[0],
    position: boxParams.position,
    elementData: {
      'feedbackType': NPS_ID,
      'name': NPS_SURVEY_PARAMS.name,
      'valueRange': NPS_SURVEY_PARAMS.valueRange,
      'order': NPS_SURVEY_PARAMS.order,
      'score': NPS_SURVEY_PARAMS.score,
      'negativeAndPositiveRanges': NPS_SURVEY_PARAMS.negativeAndPositiveRanges,
      'answers': []
    }
  });
  let userInput = new services.joint.shapes.html.UserInput({
    id: boxParams.ids[1]
  });
  box.embed(userInput);
  boxParams.graph.addCells([box, userInput]);
  return box;
}

function createSubBotBox(services, boxParams) {
  let box = new services.joint.shapes.html.SubBotBox({
    id: boxParams.ids[0],
    position: boxParams.position,
    elementData: {
      'hiddenSubBotId': boxParams.ids[1]
    }
  });
  let failureExit = new services.joint.shapes.html.SubBotExit({
    id: boxParams.ids[2],
    elementData: {
      'exitType': 'failure',
      'name': ''
    }
  });
  box.embed(failureExit);
  boxParams.graph.addCells([box, failureExit]);
  let boxView = boxParams.paper.findViewByModel(box);
  boxView.resizeBox();
  return box;
}

function createListPickerBox(services, boxParams, context) {
  let elementData = { message: { text: null } };

  const isWhatsappAccount = context.site.type === services.WhatsappFactory.getType();
  if (isWhatsappAccount) {
    elementData = {
      message: {
        text: services.$translate.instant('parameters/quick_replies/details/graph/list_picker_box/description')
      }
    }
  }
  const box = new services.joint.shapes.html.ListPickerBox({
    id: boxParams.ids[0],
    position: boxParams.position,
    elementData
  });
  const userInput = new services.joint.shapes.html.UserInput({
    id: boxParams.ids[1]
  });
  box.embed(userInput);
  boxParams.graph.addCells([box, userInput]);
  const boxView = boxParams.paper.findViewByModel(box);
  boxView.resizeBox();
  return box;
}

function createWhatsappListMessageBox(services, boxParams) {
  const box = new services.joint.shapes.html.WhatsappListMessageBox({
    id: boxParams.ids[0],
    position: boxParams.position,
    elementData: {
      openSectionsButton: services.$translate.instant('parameters/quick_replies/details/graph/edit_whatsapp_list_picker/open_sections_button_name_placeholder'),
      'message': {
        'text': services.$translate.instant('parameters/quick_replies/details/graph/whatsapp_list_picker_box/description')
      }
    }
  });

  const userInput = new services.joint.shapes.html.UserInput({
    id: boxParams.ids[1]
  });
  box.embed(userInput);
  boxParams.graph.addCells([box, userInput]);
  const boxView = boxParams.paper.findViewByModel(box);
  boxView.resizeBox();
  const sectionBoxNeeded = (boxView.getConfigurationOption('min-section') || 0) - boxView.numberOfSections;
  if (sectionBoxNeeded > 0) {
    Array.from({ length: sectionBoxNeeded }).forEach(() => boxView.addSection());
  }
  const answerBoxNeeded = (boxView.getConfigurationOption('min-answer') || 0) - boxView.numberOfAnswers;
  if (answerBoxNeeded > 0) {
    Array.from({ length: answerBoxNeeded }).forEach(() => boxView.addAnswer());
  }
  return box;
}

function createWhatsappMessageWithButtonsBox(services, boxParams) {
  const box = new services.joint.shapes.html.WhatsappMessageWithButtonsBox({
    id: boxParams.ids[0],
    position: boxParams.position,
    elementData: {}
  });

  const userInput = new services.joint.shapes.html.UserInput({
    id: boxParams.ids[1]
  });
  box.embed(userInput);
  boxParams.graph.addCells([box, userInput]);
  const boxView = boxParams.paper.findViewByModel(box);
  boxView.addButton(); // must have at least 1 button
  boxView.resizeBox();
  return box;
}

function createWhatsappTemplateBox(services, boxParams) {
  let box = new services.joint.shapes.html.WhatsappTemplateBox({
    id: boxParams.ids[0],
    position: boxParams.position,
    elementData: {}
  });
  const userInput = new services.joint.shapes.html.UserInput({
    id: boxParams.ids[1]
  });
  box.embed(userInput);
  boxParams.graph.addCells([box, userInput]);
  let boxView = boxParams.paper.findViewByModel(box);
  boxView.resizeBox();
  return box;
}

function createForkWithDelayBox(services, boxParams) {
  const box = new services.joint.shapes.html.ForkWithDelayBox({
    id: boxParams.ids[0],
    position: boxParams.position,
    elementData: {
      delay: {
        unit: 'days',
        value: 2
      }
    }
  });

  const next = new services.joint.shapes.html.Next({
    id: boxParams.ids[1]
  });
  box.embed(next);

  const nextDelayed = new services.joint.shapes.html.NextWithDelay({
    id: boxParams.ids[2]
  });
  box.embed(nextDelayed);

  boxParams.graph.addCells([box, next, nextDelayed]);

  const boxView = boxParams.paper.findViewByModel(box);
  boxView.resizeBox();
  return box;
}

function createInstagramCarrouselBox(services, boxParams) {
  let box = new services.joint.shapes.html.InstagramCarrouselBox({
    id: boxParams.ids[0],
    position: boxParams.position,
    elementData: {
      elements: [{
        carrouselElementId: 0,
        title: services.$translate.instant('parameters/quick_replies/details/graph/instagram_carrousel/carrousel_element_title_placeholder')
      }]
    }
  });
  boxParams.graph.addCells([box]);
  const boxView = boxParams.paper.findViewByModel(box);
  boxView.updateButtonGroupsAfterElementsUpdate();
  return box;
}

function createGbmCarrouselBox(services, boxParams) {
  let box = new services.joint.shapes.html.GbmCarrouselBox({
    id: boxParams.ids[0],
    position: boxParams.position,
    elementData: {
      cardWidth: 'medium',
      elements: [{
        carrouselElementId: 0,
        title: services.$translate.instant('parameters/quick_replies/details/graph/gbm_carrousel/carrousel_element_title_placeholder')
      }]
    }
  });
  boxParams.graph.addCells([box]);
  const boxView = boxParams.paper.findViewByModel(box);
  boxView.updateButtonGroupsAfterElementsUpdate();
  return box;
}

function createLineCarrouselBox(services, boxParams) {
  let box = new services.joint.shapes.html.LineCarrouselBox({
    id: boxParams.ids[0],
    position: boxParams.position,
    elementData: {
      aspectRatio: 'horizontal',
      imageSize: 'cover',
      elements: [{
        carrouselElementId: 0,
        backgroundColor: '#FFFFFF'
      }]
    }
  });
  const next = new services.joint.shapes.html.Next({
    id: boxParams.ids[1]
  });
  box.embed(next);
  boxParams.graph.addCells([box, next]);
  const boxView = boxParams.paper.findViewByModel(box);
  boxView.updateButtonGroupsAfterElementsUpdate();
  return box;
}

function createInMessageCarouselBox(services, boxParams) {
  let box = new services.joint.shapes.html.InMessageCarouselBox({
    id: boxParams.ids[0],
    position: boxParams.position,
    elementData: {
      elements: [{
        carrouselElementId: 0,
        title: services.$translate.instant('parameters/quick_replies/details/graph/inmessage_carrousel/carrousel_element_title_placeholder')
      }]
    }
  });
  boxParams.graph.addCells([box]);
  const boxView = boxParams.paper.findViewByModel(box);
  boxView.updateButtonGroupsAfterElementsUpdate();
  return box;
}

function createImageCarrouselBox(services, boxParams) {
  let box = new services.joint.shapes.html.ImageCarrouselBox({
    id: boxParams.ids[0],
    position: boxParams.position,
    elementData: {
      elements: [{
        carrouselElementId: 0
      }]
    }
  });
  const next = new services.joint.shapes.html.Next({
    id: boxParams.ids[1]
  });
  box.embed(next);
  boxParams.graph.addCells([box, next]);
  const boxView = boxParams.paper.findViewByModel(box);
  boxView.updateButtonsAfterElementsUpdate(boxParams.ids[2]);
  return box;
}

function createImageMapBox(services, boxParams, context) {
  let box = new services.joint.shapes.html.ImageMapBox({
    id: boxParams.ids[0],
    position: boxParams.position,
  });
  // default output of the box, without having to add an output element manually
  const userInput = new services.joint.shapes.html.UserInput({
    id: boxParams.ids[1],
  });
  box.embed(userInput);
  boxParams.graph.addCells([box, userInput]);
  const boxView = boxParams.paper.findViewByModel(box);
  boxView.addImageMapAddZoneButton();
  boxView.resizeBox();
  return box;
}

function createBotConnectorBox(services, boxParams) {
  let box = new services.joint.shapes.html.BotConnectorBox({
    id: boxParams.ids[0],
    position: boxParams.position,
    elementData: {
      'nextBotMetadata': '',
      'nextBotScenarioId': null,
      'isNextBotCurrentBot': null,
      'nextBotScenarioBoxId': null
    }
  });
  boxParams.graph.addCell(box);
  let boxView = boxParams.paper.findViewByModel(box);
  boxView.resizeBox();
  return box;
}

function createFacebookProductBox(services, boxParams) {
  return createBoxWithNext(services, boxParams, services.joint.shapes.html.FacebookProductBox);
}

function createRecurringNotifBox(services, boxParams) {
  const box = new services.joint.shapes.html.RecurringNotifBox({
    id: boxParams.ids[0],
    position: boxParams.position,
  });
  const next = new services.joint.shapes.html.Next({
    id: boxParams.ids[1]
  });
  const recurringNotifAccepted = new services.joint.shapes.html.RecurringNotifAccepted({
    id: boxParams.ids[2]
  });
  box.embed(recurringNotifAccepted);
  box.embed(next);
  boxParams.graph.addCells([box, recurringNotifAccepted, next]);
  const boxView = boxParams.paper.findViewByModel(box);
  boxView.resizeBox();
  return box;
}

function createHandoverBoxWithTimeoutChild(services, boxParams) {
  let box = new services.joint.shapes.html.HandoverBox({
    id: boxParams.ids[0],
    position: boxParams.position,
    timeout: 30,
    thread_control_metadata: "CONTROL_TO_ALCMEON",
    target_app_id: null
  });
  let item = new services.joint.shapes.html.HandoverItem({
    id: boxParams.ids[1],
    handoverType: 'timeout',
    description: services.$translate.instant('parameters/quick_replies/details/handover_box/timeout')
  });
  box.embed(item);
  boxParams.graph.addCells([box, item]);
  let boxView = boxParams.paper.findViewByModel(box);
  boxView.resizeBox();
  return box;
}

function createBoxWithPostbackPayload(services, boxParams, boxConstructor, postbackPayloadProperty, doAddNext, context, callbacks) {
  let box = new boxConstructor({
    id: boxParams.ids[0],
    position: boxParams.position
  });
  box.set(postbackPayloadProperty, 'alc:prod2:000:000:00000');
  if (doAddNext) {
    let next = new services.joint.shapes.html.Next({
      id: boxParams.ids[1]
    });
    box.embed(next);
    boxParams.graph.addCells([box, next]);
  } else {
    boxParams.graph.addCells([box]);
  }
  let boxView = boxParams.paper.findViewByModel(box);
  boxView.resizeBox();
  if (!boxParams.isDummy) {
    const boxIdForPostback = doAddNext ? boxParams.ids[1] : boxParams.ids[0];
    services.QuickRepliesFactory.getPostbackPayload(context.companyId, context.site.id, context.scenarioId, boxIdForPostback)
      .then(result => {
        box.set(postbackPayloadProperty, result.data.postback_payload);
        callbacks.updateSerializedGraph(box.graph);
      }, () => {
        box.set(postbackPayloadProperty, 'error');
      });
  }
  return box;
}

function createBoxWithNext(services, boxParams, boxConstructor) {
  let box = new boxConstructor({
    id: boxParams.ids[0],
    position: boxParams.position,
  });
  let next = new services.joint.shapes.html.Next({
    id: boxParams.ids[1]
  });
  box.embed(next);
  boxParams.graph.addCells([box, next]);
  let boxView = boxParams.paper.findViewByModel(box);
  if (boxView.reorderChildren) {
    boxView.reorderChildren();
  }
  boxView.resizeBox();
  return box;
}

function createMessengerGenericTemplateAManoBox(services, boxParams) {
  let box = new services.joint.shapes.html.MessengerGenericTemplateAManoBox({
    id: boxParams.ids[0],
    position: boxParams.position,
    elements: [{
      title: 'titre',
      subtitle: 'sous-titre',
      carouselElementId: 0,
    }],
  });
  boxParams.graph.addCell(box);
  let boxView = boxParams.paper.findViewByModel(box);

  boxView.setGenericTemplateHtmlContent();
  boxView.updateButtonGroupsAfterElementsUpdate();
  return box;
}

function createMessengerMediaOrButtonTemplateBox(services, boxParams, boxConstructor) {
  let box = new boxConstructor({
    id: boxParams.ids[0],
    position: boxParams.position,
    element: {
      text: '',
      pictureId: null,
      videoId: null
    }
  });
  let addButtonChild = new services.joint.shapes.html.MessengerAddButton();
  box.embed(addButtonChild);
  boxParams.graph.addCells([box, addButtonChild]);
  boxParams.paper.findViewByModel(box).resizeBox();
  return box;
}

function createIfThenElseBox(services, boxParams) {
  const box = new services.joint.shapes.html.IfThenElseBox({
    id: boxParams.ids[0],
    position: boxParams.position,
  });
  const thenChild = new services.joint.shapes.html.Then({
    id: boxParams.ids[1]
  });
  const elseChild = new services.joint.shapes.html.Else({
    id: boxParams.ids[2]
  });
  box.embed(thenChild);
  box.embed(elseChild);
  boxParams.graph.addCells([box, thenChild, elseChild]);
  boxParams.paper.findViewByModel(box).resizeBox();
  return box;
}

function createBHNBHBox(services, boxParams) {
  const box = new services.joint.shapes.html.BHNBHBox({
    id: boxParams.ids[0],
    position: boxParams.position,
  });
  const bhChild = new services.joint.shapes.html.WhenBH({
    id: boxParams.ids[1]
  });
  const nbhChild = new services.joint.shapes.html.WhenNBH({
    id: boxParams.ids[2]
  });
  box.embed(bhChild);
  box.embed(nbhChild);
  boxParams.graph.addCells([box, bhChild, nbhChild]);
  boxParams.paper.findViewByModel(box).resizeBox();
  return box;
}

function createEmailRequestForNotificationBox(services, boxParams) {
  // Create top box
  let box = new services.joint.shapes.html.EmailRequestForNotificationBox({
    id: boxParams.ids[0],
    position: boxParams.position
  });
  boxParams.graph.addCell(box);
  let boxView = boxParams.paper.findViewByModel(box);

  // Create email answer box
  let emailAnswer = boxView.createAnswer(boxParams.ids[1]);
  boxParams.graph.addCell(emailAnswer);

  boxView.resizeQuestionBox();
  return box;
}

function createPhoneRequestForNotificationBox(services, boxParams) {
  // Create top box
  let box = new services.joint.shapes.html.PhoneRequestForNotificationBox({
    id: boxParams.ids[0],
    position: boxParams.position
  });
  boxParams.graph.addCell(box);
  let boxView = boxParams.paper.findViewByModel(box);

  // Create phone answer box
  let phoneAnswer = boxView.createAnswer(boxParams.ids[1]);
  boxParams.graph.addCell(phoneAnswer);

  boxView.resizeQuestionBox();
  return box;
}

function createBZCRichLinkAManoBox(services, boxParams) {
  const box = createBoxWithNext(services, boxParams, services.joint.shapes.html.BZCRichLinkAManoBox);
  box.set('rich_link', {
    url: 'https://',
    title: services.$translate.instant('parameters/quick_replies/details/edit_generic_template_a_mano/title_label'),
    pictureId: null,
    videoId: null
  });
  boxParams.paper.findViewByModel(box).resizeBox();
  return box;
}

function createUserLanguagesBox(services, boxParams) {
  let box = new services.joint.shapes.html.UserLanguagesBox({
    id: boxParams.ids[0],
    position: boxParams.position,
  });
  let newUserLanguage = new services.joint.shapes.html.UserLanguage({
    id: boxParams.ids[1],
    elementData: {
      'label': services.$translate.instant('parameters/quick_replies/details/user_languages/unknown_language'),
      'lang': 'unknown'
    }
  });
  box.embed(newUserLanguage);
  boxParams.graph.addCells([box, newUserLanguage]);
  let boxView = boxParams.paper.findViewByModel(box);
  boxView.resizeBox();
  return box;
}

function createUserCountriesBox(services, boxParams) {
  let box = new services.joint.shapes.html.UserCountriesBox({
    id: boxParams.ids[0],
    position: boxParams.position,
  });
  let item = new services.joint.shapes.html.UserCountry({
    id: boxParams.ids[1],
    elementData: {
      'label': services.$translate.instant('parameters/quick_replies/details/user_countries/unknown_country'),
      'code': 'unknown'
    }
  });
  box.embed(item);
  boxParams.graph.addCells([box, item]);
  let boxView = boxParams.paper.findViewByModel(box);
  boxView.resizeBox();
  return box;
}

function createOptinNotOptinBox(services, boxParams) {
  const box = new services.joint.shapes.html.OptinNotOptinBox({
    id: boxParams.ids[0],
    position: boxParams.position,
    elementData: {
      'label': services.$translate.instant('parameters/quick_replies/details/optin_not_optin/optin_list'),
      'id': 'undefined'
    }
  });
  const optinChild = new services.joint.shapes.html.Optin({
    id: boxParams.ids[1]
  });
  const notOptinChild = new services.joint.shapes.html.NotOptin({
    id: boxParams.ids[2]
  });
  box.embed(optinChild);
  box.embed(notOptinChild);
  boxParams.graph.addCells([box, optinChild, notOptinChild]);
  const boxView = boxParams.paper.findViewByModel(box);
  boxView.resizeBox();
  return box;
}

function createTriggerSurveyBox(services, boxParams) {
  const box = new services.joint.shapes.html.TriggerSurveyBox({
    id: boxParams.ids[0],
    position: boxParams.position
  });
  boxParams.graph.addCell(box);
  const boxView = boxParams.paper.findViewByModel(box);
  boxView.resizeBox();
  return box;
}

function createSetCustomFieldBox(services, boxParams) {
  const box = new services.joint.shapes.html.SetCustomFieldBox({
    id: boxParams.ids[0],
    position: boxParams.position
  });
  const customFieldSuccess = new services.joint.shapes.html.SetCustomFieldSuccess({
    id: boxParams.ids[1]
  });
  const customFieldFailed = new services.joint.shapes.html.SetCustomFieldFail({
    id: boxParams.ids[2]
  });
  box.embed(customFieldSuccess);
  box.embed(customFieldFailed);
  boxParams.graph.addCells([box, customFieldSuccess, customFieldFailed]);
  const boxView = boxParams.paper.findViewByModel(box);
  boxView.resizeBox();
  return box;
}

function createPromoCodeBox(services, boxParams) {
  const box = new services.joint.shapes.html.PromoCodeBox({
    id: boxParams.ids[0],
    position: boxParams.position
  });
  const promoCodeFound = new services.joint.shapes.html.PromoCodeFound({
    id: boxParams.ids[1]
  });
  const noPromoCodesAvailable = new services.joint.shapes.html.NoPromoCodesAvailable({
    id: boxParams.ids[2]
  });
  const userAlreadyGotPromoCode = new services.joint.shapes.html.UserAlreadyGotPromoCode({
    id: boxParams.ids[3]
  });
  box.embed(promoCodeFound);
  box.embed(noPromoCodesAvailable);
  box.embed(userAlreadyGotPromoCode);
  boxParams.graph.addCells([box, promoCodeFound, noPromoCodesAvailable, userAlreadyGotPromoCode]);

  const boxView = boxParams.paper.findViewByModel(box);
  boxView.resizeBox();
  return box;
}

function createNoteBox(services, boxParams, context) {
  const box = new services.joint.shapes.html.NoteBox({
    id: boxParams.ids[0],
    position: boxParams.position,
    elementData: {
      value: null
    }
  });
  boxParams.graph.addCells([box]);
  const boxView = boxParams.paper.findViewByModel(box);
  boxView.resizeBox();
  if (!/^dummy\d$/.test(box.id)) {
    context.noteBoxesSet.add(box.id);
  }
  return box;
}

function createApiConnectorBox(services, boxParams) {
  const box = new services.joint.shapes.html.ApiConnectorBox({
    id: boxParams.ids[0],
    position: boxParams.position
  });
  const successExit = new services.joint.shapes.html.ApiConnectorSuccessExit({
    id: boxParams.ids[1]
  });
  const failExit = new services.joint.shapes.html.ApiConnectorFailExit({
    id: boxParams.ids[2]
  });
  box.embed(successExit);
  box.embed(failExit);
  boxParams.graph.addCells([box, successExit, failExit]);

  const boxView = boxParams.paper.findViewByModel(box);
  boxView.resizeBox();
  return box;
}

function createConfirmBox(services, boxParams, context) {
  let box = new services.joint.shapes.html.ConfirmBox({
    id: boxParams.ids[0],
    position: boxParams.position,
  });
  boxParams.graph.addCells([box]);
  const boxView = boxParams.paper.findViewByModel(box);

  let companyId = context.companyId;
  let siteId = context.site.id;
  let scenarioId = context.scenarioId;
  for (let i = 0; i < 2; i++) {
    services.QuickRepliesFactory.createUniqueId(companyId, siteId, scenarioId)
      .then(response => {
        boxView.addConfirmButton(response.data.id);
      },
        services.AlertingFactory.httpErrorHandler()
      );
  }
  boxView.resizeBox();
  return box;
}

function createConditionsOnUserInputBox(services, boxParams) {
  const box = new services.joint.shapes.html.ConditionsOnUserInputBox({
    id: boxParams.ids[0],
    position: boxParams.position
  });
  const otherUserInputText = new services.joint.shapes.html.OtherUserInputText({
    id: boxParams.ids[1]
  });
  box.embed(otherUserInputText);
  boxParams.graph.addCells([box, otherUserInputText]);
  const boxView = boxParams.paper.findViewByModel(box);
  boxView.resizeBox();
  return box;
}

function createConditionsVariablesMultipleBox(services, boxParams) {
  const box = new services.joint.shapes.html.ConditionsVariablesMultipleBox({
    id: boxParams.ids[0],
    position: boxParams.position,
    elementData: {
      variable: null,
      values: [],
      references: {},
    }
  });
  const elseChild = new services.joint.shapes.html.Else({
    id: boxParams.ids[1]
  });
  box.embed(elseChild);
  boxParams.graph.addCells([box, elseChild]);
  const boxView = boxParams.paper.findViewByModel(box);
  // Min 2 conditions else it is useless. 
  boxView.addValueChild();
  boxView.addValueChild();
  boxView.resizeBox();
  return box;
}

function createWhatsappWelcomeMessageBox(services, boxParams) {
  const box = new services.joint.shapes.html.WhatsappWelcomeMessageBox({
    id: boxParams.ids[0],
    position: boxParams.position,
    elementData: {
      values: [],
      references: {},
    }
  });
  const nextWhatsappWelcomeMsssagesChild = new services.joint.shapes.html.NextWhatsappWelcomeMessages({
    id: boxParams.ids[1]
  });
  const userInputChild = new services.joint.shapes.html.UserInput({
    id: boxParams.ids[2]
  });
  box.embed(nextWhatsappWelcomeMsssagesChild);
  box.embed(userInputChild);
  boxParams.graph.addCells([box, nextWhatsappWelcomeMsssagesChild, userInputChild]);
  const boxView = boxParams.paper.findViewByModel(box);
  boxView.resizeBox();
  return box;
}

function createConditionsOnCustomFieldsBox(services, boxParams) {
  const box = new services.joint.shapes.html.ConditionsOnCustomFieldsBox({
    id: boxParams.ids[0],
    position: boxParams.position
  });
  const thenChild = new services.joint.shapes.html.Then({
    id: boxParams.ids[1]
  });
  const elseChild = new services.joint.shapes.html.Else({
    id: boxParams.ids[2]
  });
  box.embed(thenChild);
  box.embed(elseChild);
  boxParams.graph.addCells([box, thenChild, elseChild]);
  const boxView = boxParams.paper.findViewByModel(box);
  boxView.resizeBox();
  return box;
}

function createOptinCTSBox(services, boxParams) {
  const box = new services.joint.shapes.html.OptinCTSBox({
    id: boxParams.ids[0],
    position: boxParams.position,
  });
  boxParams.graph.addCell(box);
  const boxView = boxParams.paper.findViewByModel(box);
  boxView.resizeBox();
  return box;
}

function createAiConnectorBox(services, boxParams) {
  const box = new services.joint.shapes.html.AiConnectorBox({
    id: boxParams.ids[0],
    position: boxParams.position,
    elementData: {
      realType: 'aiConnector',
      hiddenSubBotId: boxParams.ids[1],
      mode: 'internal',
    }
  });

  let failureExit = new services.joint.shapes.html.AiConnectorExit({
    id: boxParams.ids[2],
    elementData: {
      'exitType': 'failure',
      'name': ''
    }
  });

  box.embed(failureExit);
  boxParams.graph.addCells([box, failureExit]);
  const boxView = boxParams.paper.findViewByModel(box);
  boxView.resizeBox();
  return box;
}

function createWaitForMessageBox(services, boxParams) {
  let box = new services.joint.shapes.html.WaitForMessageBox({
    id: boxParams.ids[0],
    position: boxParams.position,
  });

  boxParams.graph.addCell(box);

  let boxView = boxParams.paper.findViewByModel(box);
  boxView.addAnswer(services.$translate.instant('parameters/quick_replies/details/default_answer'), 'user-input', false);

  return box;
}

function createAISatisfactionBox(services, boxParams) {
  const box = new services.joint.shapes.html.AiSatisfactionBox({
    id: boxParams.ids[0],
    position: boxParams.position,
    elementData: {
      descriptionLabel: services.$translate.instant('parameters/quick_replies/details/graph/ai-satisfaction/default-description'),
      references: {}
    }
  });

  const aiSatisfactionAnswerExitYesChild = new services.joint.shapes.html.AiSatisfactionAnswerExit({
    id: boxParams.ids[1],
    elementData: {
      type: 'Yes',
      label: services.$translate.instant('parameters/quick_replies/details/graph/ai-satisfaction/default-yes'),
    }
  });
  const aiSatisfactionAnswerExitNoChild = new services.joint.shapes.html.AiSatisfactionAnswerExit({
    id: boxParams.ids[2],
    elementData: {
      type: 'No',
      label: services.$translate.instant('parameters/quick_replies/details/graph/ai-satisfaction/default-no'),
    }
  });
  const userInputChild = new services.joint.shapes.html.UserInput({
    id: boxParams.ids[3]
  });

  box.embed(aiSatisfactionAnswerExitYesChild);
  box.embed(aiSatisfactionAnswerExitNoChild);
  box.embed(userInputChild);

  boxParams.graph.addCells([box, aiSatisfactionAnswerExitYesChild, aiSatisfactionAnswerExitNoChild, userInputChild]);
  const boxView = boxParams.paper.findViewByModel(box);
  boxView.resizeBox();
  return box;
}


function createTextMatchBox(services, boxParams) {
  const box = new services.joint.shapes.html.TextMatchBox({
    id: boxParams.ids[0],
    position: boxParams.position,
    elementData: {
      beforeMatch: '',
      afterMatch: '',
      variable: '',
      references: {
        matchBoxId: null,
        notMatchBoxId: null,
      }
    }
  });

  const textMatchAnswerExitMatchedChild = new services.joint.shapes.html.TextMatchAnswerExit({
    id: boxParams.ids[1],
    elementData: {
      type: 'match',
      label: 'parameters/quick_replies/details/graph/text-match/default-matched',
    }
  });
  const textMatchAnswerExitNotMatchedChild = new services.joint.shapes.html.TextMatchAnswerExit({
    id: boxParams.ids[2],
    elementData: {
      type: 'notMatch',
      label: 'parameters/quick_replies/details/graph/text-match/default-not-matched',
    }
  });


  box.embed(textMatchAnswerExitMatchedChild);
  box.embed(textMatchAnswerExitNotMatchedChild);

  boxParams.graph.addCells([box, textMatchAnswerExitMatchedChild, textMatchAnswerExitNotMatchedChild]);
  const boxView = boxParams.paper.findViewByModel(box);
  boxView.resizeBox();
  return box;
}
